
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/san-pham/hide",
      function () {
        return require("private-next-pages/san-pham/hide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/san-pham/hide"])
      });
    }
  